import { resetALL } from "../../../../../../../.globals/redux/actions";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { clientMutation } from '../../../../../../../core/data/GraphQLApi';
import { endpoints } from '../../../../../../../core/defaultValues';

const INIT_STATE = {
    loadingUpdate: false,
    update: null,
    error: null
};

export const updateDriverCaseAccountConfig = createAsyncThunk(
    "coachingEducation/updateDriverCaseAccountConfig",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await clientMutation(
                `
                mutation updateDriverCaseAccountConfig($config: AWSJSON!, $configType: String!) {
                    updateDriverCaseAccountConfig(config: $config, configType: $configType)
                }`,
                {
                    config: JSON.stringify(payload.config),
                    configType: "functions_coachingEducation"
                },
                endpoints.GRAPHQL_GENERAL_V2
            );
            
            // Check for GraphQL errors in response
            if (response.errors && response.errors.length > 0) {
                return rejectWithValue(response.errors[0].message);
            }
            
            return { success: response.updateDriverCaseAccountConfig, isEnabled: payload.config.isEnabled };
        } catch (exc) {
            // Handle network or other errors
            const errorMessage = exc.errors?.[0]?.message || exc.message || 'Unknown error';
            return rejectWithValue(errorMessage);
        }
    }
);

const coachingEducationRedux = createSlice({
    name: "coachingEducation",
    initialState: INIT_STATE,
    reducers: {
        resetCoachingEducation(state, action) {
            return action.payload ? { ...state, ...action.payload } : INIT_STATE;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);

        builder.addCase(updateDriverCaseAccountConfig.pending, (state) => {
            state.loadingUpdate = true;
        })
        builder.addCase(updateDriverCaseAccountConfig.fulfilled, (state, action) => {
            state.loadingUpdate = false;
            state.update = action.payload;
        })
        builder.addCase(updateDriverCaseAccountConfig.rejected, (state, action) => {
            state.loadingUpdate = false;
            state.update = { success: false, error: action.payload };
        })
    },
});

export const { resetCoachingEducation } = coachingEducationRedux.actions;
export default coachingEducationRedux.reducer;